import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import OrderFilterBlock from '@/views/orderManage/orderList/components/OrderFilterBlock.vue';
import OrderTableBlock from '@/views/orderManage/orderList/components/OrderTableBlock.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const tableRef = ref(null);
    const loading = ref(false);
    const tableType = ref('1');
    const filterSubmit = obj => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(obj);
    };
    const closeMore = bool => {
      var _tableRef$value2;
      (_tableRef$value2 = tableRef.value) === null || _tableRef$value2 === void 0 || _tableRef$value2.closeMore(bool);
    };
    const updateLoading = e => {
      loading.value = e;
    };
    const changeType = e => {
      tableType.value = e;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(OrderFilterBlock, {
        onFilterSubmit: filterSubmit,
        onCloseMore: closeMore,
        loading: loading.value,
        onChangeType: changeType
      }, null, 8, ["loading"]), _createVNode(OrderTableBlock, {
        ref_key: "tableRef",
        ref: tableRef,
        onUpdateLoading: updateLoading,
        "table-type": tableType.value
      }, null, 8, ["table-type"])]);
    };
  }
});